import React from "react";
import _ from "lodash";

import ModalBox from "components/ModalBox";
import Input from "components/Input";
import Select from "components/Select";
import RangeDatepicker from "components/RangeDatepicker";
import Button from "components/Button";
import NumbersRange from "./NumbersRange";
import FilterGenerator from "helpers/filter";

import "./style.scss";
import { modalTypes } from "constants/index";

interface IProps {
  visible: boolean;
  onCloseModal: () => void;
  isLoading: boolean;
  downloadFile: (format: string, type: string, filter: string) => void;
  roleIds: any[];
  currentCustomer: any;
}

interface IState {
  data: any;
}

class AreaStatementModal extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
    };
  }

  private renderFilter = () => {
    const { data } = this.state;
    const { currentCustomer } = this.props;
    const Q = new FilterGenerator();
    Q.and("LicensorNumber", currentCustomer.Number, "string");
    Q.and("Culitvar", data.Cultivar, "string");
    Q.and("HarvestYear", data.HarvestYear, "number");
    Q.and("ProductGroup", data.ProductGroup, "string");

    this.props.downloadFile("Excel", modalTypes.areaStatement, Q.query);
  };

  private handleChange = (value, name) => {
    this.setState((prevState) => ({
      data: _.set(prevState.data, name, value),
    }));
  };

  private maskOnInput = (e, name) => {
    const value = e.target.validity.valid
      ? e.target.value
      : _.get(this.state.data, name, "");

    this.handleChange(value, name);
  };

  public render() {
    const { visible, onCloseModal, isLoading, roleIds } = this.props;
    const { data } = this.state;
    return (
      <ModalBox visible={visible} onCloseModal={onCloseModal}>
        <div className="modal-content">
          <Input
            label="HARVEST_YEAR"
            pattern="[0-9]*"
            maxLength={4}
            onChange={(e) => this.maskOnInput(e, "HarvestYear")}
            value={data.HarvestYear}
            containerClassName="report-row"
          />
          <Input
            label="DELIVERIES_GENUS"
            onChange={(e) => this.handleChange(e.target.value, "ProductGroup")}
            value={data.ProductGroup}
            containerClassName="report-row"
          />
          <Input
            label="DELIVERIES_CULTIVAR"
            onChange={(e) => this.handleChange(e.target.value, "Cultivar")}
            value={data.Cultivar}
            containerClassName="report-row"
          />
        </div>
        <div className="btn-container">
          <Button
            id="download-reports-invoiced-delivery"
            kind="primary"
            onClick={this.renderFilter}
            isLoading={isLoading}
            disabled={isLoading}
          >
            {isLoading ? "LOADING" : "REPORTS_INVOICED_AREA_STATEMENT_OVERVIEW"}
          </Button>
        </div>
      </ModalBox>
    );
  }
}

export default AreaStatementModal;
